import {useMatches as useMatchesTanStack} from '@tanstack/react-router'

export function useMatches() {
  const matches = useMatchesTanStack()
  // Convert TanStack matches to React Router UIMatch format
  return matches.map(match => {
    let id: string = match.routeId
    if (typeof match.context === 'object' && 'dataRouterId' in match.context) {
      id = match.context.dataRouterId
    }
    return {
      id,
      pathname: match.pathname,
      params: match.params,
      handle: 'reactRouterHandle' in match.staticData ? match.staticData.reactRouterHandle : undefined,
      loaderData: match.loaderData, // Value may be undefined, but property must be present in react-router
      data: match.loaderData, // Deprecated alias for loaderData in react-router
    }
  })
}
